import React, {useState} from 'react'
import {LocalLink} from 'i18n/LocalLink'
import {useOrganizationAuth} from 'organization/Auth/Providers/OrganizationAuthProvider'
import {routes} from 'routes/routes'
import {useI18n} from 'i18n/I18nContext'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import LogoutIcon from '@mui/icons-material/Logout'
import Avatar from 'react-avatar'
import CorporateFareIcon from '@mui/icons-material/CorporateFare'

export const ProfileLinks = () => {
  const {t} = useI18n()
  const {logout, user} = useOrganizationAuth()

  const [userDropdown, setuserDropdown] = useState<boolean>(false)

  const handleShowuserDrowdown = () => {
    setuserDropdown(!userDropdown)
  }

  return (
    <>
      <div className="nav-item p-relative">
        <button id="userportfolio" onClick={handleShowuserDrowdown}>
          <div className="user__portfolio">
            <div className="user__portfolio-thumb">
              <Avatar
                name={user?.first_name + ' ' + user?.last_name}
                round={true}
                size="50"
                textSizeRatio={3}
              />
            </div>
            <div className="user__content">
              <span>
                {user?.first_name} {user?.last_name}
              </span>
            </div>
          </div>
        </button>
        <div className={`user__dropdown ${userDropdown ? 'user-enable' : ' '}`}>
          <ul>
            <li>
              <LocalLink to={routes.organization.list}>
                <CorporateFareIcon /> {t('nav.organizations')}{' '}
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.organization.profile}>
                <AccountBoxIcon /> {t('nav.profile')}{' '}
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.organization.billing}>
                <CreditCardIcon />
                {t('nav.payments')}
              </LocalLink>
            </li>
            <li>
              <button type="button" onClick={logout}>
                <LogoutIcon />
                {t('nav.logout')}
              </button>{' '}
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
